export const docreaderPrivacy = {
  lastUpdated: 'July 13, 2026',
  title: 'Privacy Policy',
  intro: 'How DocReader handles local documents, file permissions, ads, analytics, diagnostics, and support requests.',
  sections: [
    {
      title: 'Overview',
      body: [
        'DocReader is a document viewing and editing tool for Android. It helps you scan, find, open, preview, edit, and save documents on your device, including PDF, Word, Excel, PowerPoint, TXT, and other supported file types.',
        'DocReader is designed to process your documents mainly on your device. The current version does not upload your document contents to our servers unless you choose to share files through your device, another app, or an external service.',
      ],
    },
    {
      title: 'Local Files and Document Information',
      body: [
        'To help you find and open documents, DocReader may request file, media, storage, or All files access permissions provided by Android.',
        'After you grant permission, DocReader may read local file information such as file names, file paths, file sizes, file modification times, file types, and the contents of documents that you choose to open, view, edit, save, or share.',
        'DocReader uses this information to scan supported documents, display document lists, open previews, edit supported files, save changes, and keep document-related features working on your device.',
      ],
    },
    {
      title: 'All Files Access',
      body: [
        'DocReader may request Android Manage All Files access when needed for its core document management features. This permission helps the app locate documents across shared storage and open or save files outside app-specific folders.',
        'DocReader does not use All files access to upload your documents to our servers, sell your files, or read files for unrelated advertising purposes.',
        'You can grant, deny, or revoke file permissions in your device settings. If you deny or revoke these permissions, document scanning, opening, editing, or saving features may not work properly.',
      ],
    },
    {
      title: 'Local Preferences and App Data',
      body: [
        'DocReader may store local preferences on your device, such as language settings, interface settings, recently used options, editing preferences, or basic app configuration.',
        'PDF preview copies, temporary files, thumbnails, or cache files may be stored in the app cache area. Edited copies may be saved in the original file location, an app folder, or a location that you choose.',
      ],
    },
    {
      title: 'Ads, Analytics, and Diagnostics',
      body: [
        'DocReader may use Google Mobile Ads, AdMob, Firebase, Google Analytics for Firebase, Firebase Crashlytics, or similar services to show ads, measure ad performance, analyze app usage, diagnose crashes, improve stability, and prevent fraud or abuse.',
        'These services may automatically collect or process information such as IP address, device model, operating system, app version, app interactions, advertising identifiers, App Set ID, crash logs, performance data, diagnostic events, ad impressions, ad clicks, and SDK status information.',
        'Third-party providers process this information according to their own privacy policies and platform terms. Google explains how it uses information from apps and sites that use its services in Google privacy materials.',
      ],
    },
    {
      title: 'How We Use Information',
      body: [
        'We use information to operate DocReader, scan and display supported documents, open and preview files, edit and save selected files, remember preferences, show and measure ads, analyze feature usage, improve performance, fix bugs, prevent misuse, respond to support requests, and comply with legal, platform, or security requirements.',
        'We do not sell your personal document contents. We do not use your documents for AI training.',
      ],
    },
    {
      title: 'Sharing and Third Parties',
      body: [
        'We may share or allow processing of limited information with service providers that help operate the app, including advertising, analytics, diagnostics, crash reporting, security, app store, hosting, and support providers.',
        'We may also disclose information if required by law, legal process, government request, app store policy, or to protect users, developers, third parties, rights, safety, or property.',
        'If you choose to export, open, or share a document through another app or external service, that third party may process the file according to its own terms and privacy policy.',
      ],
    },
    {
      title: 'Data Retention and Deletion',
      body: [
        'Documents remain primarily on your device unless you choose to share or export them. Local app data may remain until you delete files, clear cache, clear app data, use available deletion controls, or uninstall DocReader.',
        'Advertising, analytics, diagnostics, app store, or support records may be retained by us or third-party providers for the periods needed to operate services, comply with law, prevent fraud, resolve disputes, maintain security, or meet platform obligations.',
        'For privacy questions or deletion requests related to support communications or account-linked data that we may hold, contact us at yuw558071@gmail.com.',
      ],
    },
    {
      title: 'Security',
      body: [
        'We use reasonable technical and organizational measures to protect information handled by DocReader. However, no method of electronic storage, device processing, or internet transmission can be guaranteed to be completely secure.',
        'You are responsible for keeping your device secure and for backing up important documents before editing or saving changes.',
      ],
    },
    {
      title: 'Children Privacy',
      body: [
        'DocReader is not directed to children under 13. We do not knowingly collect personal information from children under 13. If you believe a child has provided personal information to us, please contact us so we can take appropriate action.',
      ],
    },
    {
      title: 'Your Choices',
      body: [
        'You can grant or revoke file, storage, media, notification, or other permissions in your device settings. You can also reset or limit your advertising identifier where supported by your device.',
        'You may delete local app data by clearing app data or uninstalling DocReader. Deleting the app may not delete documents that you saved outside the app folder.',
      ],
    },
    {
      title: 'Changes',
      body: [
        'We may update this Privacy Policy as DocReader changes. The latest version will be posted on this page with the updated date. Continued use of DocReader after an update means you accept the updated policy.',
      ],
    },
    {
      title: 'Contact',
      body: [
        'For privacy questions, contact us at yuw558071@gmail.com.',
      ],
    },
  ],
};

export const docreaderTerms = {
  lastUpdated: 'July 13, 2026',
  title: 'Terms of Service',
  intro: 'The rules for using DocReader, local document features, file permissions, ads, and related 2xHappiness services.',
  sections: [
    {
      title: 'Acceptance of Terms',
      body: [
        'By downloading, accessing, or using DocReader, you agree to these Terms of Service. If you do not agree, please do not use the app.',
        'These terms apply to DocReader. Other 2xHappiness apps may have separate terms that match their own features.',
      ],
    },
    {
      title: 'Service Description',
      body: [
        'DocReader provides local document scanning, viewing, previewing, editing, saving, and sharing features for supported files, including PDF, Word, Excel, PowerPoint, TXT, and other compatible document types.',
        'Available features may vary by app version, device model, operating system, file format, file encoding, encryption, storage location, and permission status.',
      ],
    },
    {
      title: 'License to Use DocReader',
      body: [
        'Subject to your compliance with these terms, 2xHappiness grants you a limited, non-exclusive, non-transferable, revocable license to install and use DocReader on your personal device.',
        'You may not copy, modify, distribute, sell, lease, reverse engineer, decompile, attempt to extract source code from, or create derivative works of DocReader except where applicable law allows it.',
      ],
    },
    {
      title: 'Your Documents and Responsibility',
      body: [
        'You keep ownership of the documents, text, files, and other content that you open, edit, save, export, or share through DocReader.',
        'You are responsible for making sure you have the legal right to access, view, edit, save, or share each document you use with DocReader.',
        'You should back up important documents before editing, converting, overwriting, or saving changes. We are not responsible for data loss or document changes caused by user action, permission restrictions, corrupted files, device issues, operating system behavior, storage errors, or third-party apps beyond what applicable law requires.',
      ],
    },
    {
      title: 'Permissions and Device Access',
      body: [
        'DocReader may request file, media, storage, notification, or All files access permissions to provide document scanning, opening, editing, saving, and sharing features.',
        'If you deny or revoke required permissions, some features may be unavailable or may not work correctly. You agree that DocReader may access compatible documents and necessary file information after you grant permission for those features.',
      ],
    },
    {
      title: 'Ads and Third-Party Services',
      body: [
        'DocReader may display ads and may use third-party advertising, analytics, diagnostics, crash reporting, app store, or support services.',
        'Third-party services may process information according to their own terms and privacy policies. We do not control third-party ads, external links, third-party SDK behavior, or services outside DocReader.',
      ],
    },
    {
      title: 'Intellectual Property',
      body: [
        'DocReader, including its software, code, interface, designs, name, icons, features, and related materials, is owned by 2xHappiness or its licensors and is protected by intellectual property laws.',
        'These terms do not transfer ownership of DocReader or 2xHappiness materials to you. Your documents remain owned by you or the relevant rights holders.',
      ],
    },
    {
      title: 'Prohibited Conduct',
      body: [
        'You may not use DocReader to violate laws, infringe intellectual property, invade privacy, spread harmful or deceptive content, bypass security measures, interfere with ads or analytics, damage systems, or access, modify, store, or share files without authorization.',
        'You may not misuse DocReader in a way that harms other users, third-party services, device systems, app stores, or 2xHappiness.',
      ],
    },
    {
      title: 'Disclaimers',
      body: [
        'DocReader is provided on an as-is and as-available basis. We do not guarantee that the app will be uninterrupted, error-free, secure, compatible with every file, or suitable for every purpose.',
        'Document parsing, previewing, editing, saving, or rendering results may differ because of file format, encoding, encryption, corruption, unsupported features, device performance, storage restrictions, or operating system limitations. You should review important output before relying on it.',
      ],
    },
    {
      title: 'Limitation of Liability',
      body: [
        'To the maximum extent permitted by law, 2xHappiness is not liable for indirect, incidental, special, consequential, punitive, or exemplary damages, or for loss of data, documents, profits, business, goodwill, or other intangible losses related to your use of or inability to use DocReader.',
      ],
    },
    {
      title: 'Changes and Termination',
      body: [
        'We may update, modify, suspend, or discontinue some or all DocReader features at any time. We may also limit or terminate your right to use DocReader if you violate these terms.',
        'We may update these terms from time to time. The latest version will be posted on this page with the updated date. Continued use of DocReader after changes means you accept the updated terms.',
      ],
    },
    {
      title: 'Contact',
      body: [
        'Questions about these terms can be sent to yuw558071@gmail.com.',
      ],
    },
  ],
};
